import { bhStoreApiRequest } from '@lib/request'
import { Customer } from '@medusajs/medusa'
import { useCallback, useEffect, useState } from 'react'

/** Return a boolean for whether or not the provided customer's account has
 * been rejected by Barnhill or not. */
function useAccountRejectedCheck(customer?: Omit<Customer, 'password_hash'>) {
  const [loading, setLoading] = useState(false)
  const [isRejected, setIsRejected] = useState(false)
  const checkIsRejected = useCallback(async () => {
    setLoading(true)
    try {
      if (customer) {
        // check if the customer is a b2b customer
        const { data } = await bhStoreApiRequest<{
          isRejected: boolean
        }>(`/customers/is-rejected`)
        setIsRejected(data.isRejected)
      } else {
        setIsRejected(false)
      }
    } catch (error) {
      setIsRejected(false)
    } finally {
      setLoading(false)
    }
  }, [customer])

  useEffect(() => {
    checkIsRejected()
  }, [checkIsRejected])

  return {
    isRejected,
    loading,
  }
}

export default useAccountRejectedCheck
